<template>
  <div class="container">
    <div class="content_top">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/member/list' }">
          成员介绍
        </el-breadcrumb-item>
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content_wrapper">
      <div class="member_left">
        <el-card class="member_card member_left">
          <img
            :src="member.avatar"
            :alt="member.name"
            class="avatar"
          />
          <p class="member_name">{{ member.name }}</p>
          <p class="member_text">{{ member.role }}</p>
          <p class="member_text">{{ member.email }}</p>
        </el-card>
      </div>
      <div class="member_right">
        <div class="info_item">
          <div class="info_title">基本信息</div>
          <div class="info_content">{{ member.basicMessage }}</div>
        </div>
        <div class="info_item">
          <div class="info_title">个人荣誉</div>
          <div class="info_content">{{ member.honor }}</div>
        </div>
        <div class="info_item">
          <div class="info_title">学术成果</div>
          <div class="info_content">{{ member.academicAchievement }}</div>
        </div>
        <div class="info_item">
          <div class="info_title">其他</div>
          <div class="info_content">{{ member.others }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import requests from "@/api/request";

export default {
  name: "MemberDetail",
  data() {
    return {
      member: {}
    };
  },
  mounted(){
    this.getMember(this.$route.query.memberId);
  },
  methods: {
    // 获取分页数据
    async getMember(id) {
      return requests({
        url: "/member/showMembersInfo?id=" + id,
        method: "GET"
      }).then(res => {
        this.$set(this, 'member', res.data);
      }).catch(err => {
        console.log('error', err)
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error'
        });
      });
    },
  }
};
</script>
<style scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}

.content_top {
  margin: 20px 0;
}

.content_wrapper {
  display: flex;
  justify-content: flex-start;
  padding: 20px 0;
  margin-bottom: 20px;
  min-height: calc(100vh - 220px);
}

.el-breadcrumb ::v-deep .el-breadcrumb__inner:hover {
  color: #63065f;
}

.member_left {
  width: 300px;
}

.member_card {
  height: 100%;
  width: 240px;
  background-color: #63065f;
}

.member_card .avatar {
  width: 160px;
  height: 200px;
  border-radius: 50%;
  border: #63065f 1px solid;
}

.member_card p {
  margin: 0;
  color: white;
}

.member_name {
  line-height: 2em;
  font-size: large;
}

.member_text {
  color: #6c6c6c;
  /*font-size: ;*/
}

.info_item {
  /*background-color: #42b983;*/
  text-align: left;
  margin: 0 0 20px 40px;
}

.info_title {
  font-size: larger;
  color: #63065f;
  font-weight: bold;
  line-height: 2em;
  border-bottom: solid #4e4e4e 1px;
  margin-bottom: 10px;
}
</style>
